import React, { useState } from 'react';
import InfoModal from '../InfoModal';
import { useTranslation } from 'react-i18next';
import forwardIcon from '../../assets/modal/forward.png';
import returnIcon from '../../assets/modal/return.png';
import flowrateIcon from '../../assets/modal/flowrate.png';

interface TemperatureValuesProps {
  values: { key: string; label: string; temperature: number }[];
}

export interface InfoModalData {
  title: string;
  description: string;
  icon: string;
}

const TemperatureValues: React.FC<TemperatureValuesProps> = ({ values }) => {
  const { t } = useTranslation();
  const modalInfoContent: Record<string, Omit<InfoModalData, 'key'>> = {
    'forwardWaterTemperature1DegC': {
      title: t('dataUsageModalInfos.forwardWaterTemperature'),
      description: t('dataUsageModalInfos.forwardWaterTemperatureDescription'),
      icon: forwardIcon
    },
    'returnWaterTemperature1DegC': {
      title: t('dataUsageModalInfos.returnWaterTemperature'),
      description: t('dataUsageModalInfos.returnWaterTemperatureDescription'),
      icon: returnIcon
    },
    'flowRateLiterPerHour1': {
      title: t('dataUsageModalInfos.heatingCoolingVolumeMeter'),
      description: t('dataUsageModalInfos.heatingCoolingVolumeMeterDescription'),
      icon: flowrateIcon
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState<InfoModalData | null>(null);
  const handleDataRowClick = (value: any) => {
    const content = modalInfoContent[value.key] || modalInfoContent['default'];
    setModalData(content);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalData(null);
  };

  return (
    <div className="TemperatureValues">
      <h3>Hőmérsékleti értékek</h3>
      {values.map((value, index) => (
        <div 
          key={index} 
          className="dataRow" 
          onClick={() => handleDataRowClick(value)}
          style={{ cursor: 'pointer' }}
        >
          <p>
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
              <path d="M10.0915 18.3332C5.48904 18.3332 1.75821 14.6023 1.75821 9.99984C1.75821 5.39734 5.48904 1.6665 10.0915 1.6665C14.694 1.6665 18.4249 5.39734 18.4249 9.99984C18.4249 14.6023 14.694 18.3332 10.0915 18.3332ZM10.0915 16.6665C11.8597 16.6665 13.5553 15.9641 14.8056 14.7139C16.0558 13.4636 16.7582 11.7679 16.7582 9.99984C16.7582 8.23173 16.0558 6.53603 14.8056 5.28579C13.5553 4.03555 11.8597 3.33317 10.0915 3.33317C8.32343 3.33317 6.62774 4.03555 5.3775 5.28579C4.12725 6.53603 3.42488 8.23173 3.42488 9.99984C3.42488 11.7679 4.12725 13.4636 5.3775 14.7139C6.62774 15.9641 8.32343 16.6665 10.0915 16.6665ZM10.0915 8.33317C10.3126 8.33317 10.5245 8.42097 10.6808 8.57725C10.8371 8.73353 10.9249 8.94549 10.9249 9.1665V13.3332C10.9249 13.5542 10.8371 13.7661 10.6808 13.9224C10.5245 14.0787 10.3126 14.1665 10.0915 14.1665C9.87053 14.1665 9.65857 14.0787 9.50229 13.9224C9.34601 13.7661 9.25821 13.5542 9.25821 13.3332V9.1665C9.25821 8.94549 9.34601 8.73353 9.50229 8.57725C9.65857 8.42097 9.87053 8.33317 10.0915 8.33317ZM10.0915 7.49984C9.87053 7.49984 9.65857 7.41204 9.50229 7.25576C9.34601 7.09948 9.25821 6.88752 9.25821 6.6665C9.25821 6.44549 9.34601 6.23353 9.50229 6.07725C9.65857 5.92097 9.87053 5.83317 10.0915 5.83317C10.3126 5.83317 10.5245 5.92097 10.6808 6.07725C10.8371 6.23353 10.9249 6.44549 10.9249 6.6665C10.9249 6.88752 10.8371 7.09948 10.6808 7.25576C10.5245 7.41204 10.3126 7.49984 10.0915 7.49984Z"/>
            </svg>
            {value.label}
          </p>
          <p className="value">{value.temperature}</p>
        </div>
      ))}
      
      {isModalOpen && modalData && (
        <InfoModal
          isOpen={isModalOpen}
          onClose={closeModal}
          title={modalData.title}
          description={modalData.description}
          icon={modalData.icon}
        />
      )}
    </div>
  );
};

export default TemperatureValues;
